import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const DisketteIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path fillRule="evenodd" clipRule="evenodd" d="M3 4.3C3 3.57 3.59 3 4.28 3h11.58L21 8.14v11.58c0 .7-.58 1.28-1.3 1.28H4.3A1.3 1.3 0 0 1 3 19.7V4.3Zm2.57 1.27h7.72v3.86H5.57V5.57ZM12 17.14A2.57 2.57 0 1 0 12 12a2.57 2.57 0 0 0 0 5.14Z"/>
    </SvgIcon>
);
